export default __webpack_public_path__ + "static/media/Pinch.e75a91dd.svg";